module.exports = __webpack_public_path__ + "static/media/save-ok.56bae457.mp3";